import Layout from "components/structure/Layout";
import React from "react";
import RuleTable from "../RuleTable";
import {
  Box,
  Grid,
  Container,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import Delegation from "assets/delegation.svg";
import AddButton from "assets/add.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import RoleService from "services/RoleService";
import { useContext } from "react";
import { SnackbarContext } from "context/snackBarContext";
import { useEffect } from "react";
import drag from "assets/drag.svg";
import UserCreationService from "services/UserCreationService";
import SearchIcon from "@mui/icons-material/Search";
import RuleService from "services/RuleService";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AuthData } from "auth/AuthWarpper";
import { useTranslation } from "react-i18next";

const CreateNewRule = () => {
  const navigate = useNavigate();
  const {t,i18n} = useTranslation()
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
  const obj = {
    id: "",
    name: "",
  };
  const [func1, setFunc1] = useState(obj);
  const [func2, setFunc2] = useState(obj);
  const { user } = AuthData();

  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    setInputValue(event.target.value);
    // Example validation: Check if input is empty
    if (event.target.value.trim() === "") {
      setError(true);
    } else {
      setError(false);
    }
  };

  const [expanded, setExpanded] = useState("panel1");
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);

  const handleChanges = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const searchFunctionality = (searchTerm) => {
    return data.map(heading => {
      // Filter each mergedSubHeadings based on the functionality_name match
      const filteredSubHeadings = heading.mergedSubHeadings.map(subHeading => {
        // Filter headingData based on the searchTerm
        const filteredHeadingData = subHeading.headingData.filter(func =>
          func.functionality_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        
        // Return the subHeading if any functionality matches the search term
        return filteredHeadingData.length > 0
          ? { ...subHeading, headingData: filteredHeadingData }
          : null;
      }).filter(Boolean); // Filter out subHeadings with no matches
      
      // Return the heading if any mergedSubHeadings match
      return filteredSubHeadings.length > 0
        ? { ...heading, mergedSubHeadings: filteredSubHeadings }
        : null;
    }).filter(Boolean); // Filter out headings with no matches
  };
  
  // Example usage:


  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    if (query.trim() === '') {
      setFilteredResults(data); // Clear results when search query is empty
    } else {
     // const searchTerm = 'Functionality 2';
      const result = searchFunctionality(query);
      setFilteredResults(result);
    }
  };


  const transformResponse = (response) => {
    const result = {};
    let headingKeys = Object.keys(response)
    let totalArray = []
    // Iterate over each key in the "Non-Privileged" object
    headingKeys.forEach((key) => {
      let subHeadingKeys =  Object.keys(response[key])
      subHeadingKeys.forEach(subKey => {
        let getTheArray = response[key][subKey]
        let obj = {
          headingName: key,
          subHeadingName: subKey,
          headingData: getTheArray
        }        
        totalArray.push(obj)
      });
  
    });

    return totalArray;
  };

  const createRule = async () => {

    setLoading(true);
    const payload = {
      functionalityId1: func1.id,
      functionalityId2: func2.id,
      countryCode: user?.countryCode,
      isDeleted: false,
      isActive: true,
      createdDateTimeUTC: new Date().toISOString(),
      createdByUser: user?.userName,
      modifiedDateTimeUTC: new Date().toISOString(),
      modifiedByUser: user?.userName,
    };
    try {
      const response = await RuleService.createRule(payload);
      setSeverity("success");
      setMessage("Added successfully");
      setOpenAlert(true);
      setLoading(false);
      setLoading(false);
      navigate("/conflictIndicator");
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      //setData([]);
    }
    setLoading(false);
  };

  const handleDragStart = (event, con) => {
    event.dataTransfer.setData("application/json", JSON.stringify(con));
  };

  const handleDrop = (event) => {
    event.preventDefault();
    let droppedItem = JSON.parse(
      event.dataTransfer.getData("application/json")
    );
    let obj = {
      id: droppedItem.functionality_id,
      name: droppedItem.functionality_name,
    };

    if (func2.id == droppedItem.functionality_id) {
      // dont do anything
    } else {
      setFunc1(obj);
    }
    // setFunc1((prev) => (prev ? `${prev}, ${formattedValue}` : formattedValue));
  };

  const handleDragOver = (event) => {

    event.preventDefault(); // Necessary to allow drop
  };

  const handleDrop2 = (event) => {
    event.preventDefault();
    let droppedItem = JSON.parse(
      event.dataTransfer.getData("application/json")
    );
    let obj = {
      id: droppedItem.functionality_id,
      name: droppedItem.functionality_name,
    };
    if (func1.id == droppedItem.functionality_id) {
      // dont do anything
    } else {
      setFunc2(obj);
    }
  };

  const handleDragOver2 = (event) => {

    event.preventDefault(); // Necessary to allow drop
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await RuleService.getRuleModules();

      const responseData = response?.data?.response;
      
      let getExactData = transformResponse(responseData);
      let mergedData = []
      if(getExactData.length){
        mergedData = Object.values(getExactData.reduce((acc, current) => {
          const { headingName, subHeadingName, headingData } = current;
          
          // If the headingName doesn't exist yet, initialize it with an empty subHeading array
          if (!acc[headingName]) {
            acc[headingName] = {
              headingName: headingName,
              mergedSubHeadings: []
            };
          }
          
          // Add subHeadingName and its corresponding headingData to the mergedSubHeadings array
          acc[headingName].mergedSubHeadings.push({
            subHeadingName: subHeadingName,
            headingData: headingData
          });
        
          return acc;
        }, {}));
      }

      if (mergedData.length) {
        setFilteredResults(mergedData)
        setData(mergedData);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setSeverity("error");
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setMainData([]);
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    // setData(sampleData)
    fetchData();
  }, []);

  return (
    <Layout>
      <Box sx={{ paddingBottom: "100px" }}>
        <Box
          sx={{
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "30px",
            minHeight: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "800px",
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: "16px",
            }}
          >
            <Box sx={{ maxHeight: "400px", overflowY: "auto" }}>
              <Box
                sx={{
                  padding: "20px 30px",
                  borderBottom: "solid 1px rgba(14, 43, 99, 0.2)",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      label={t("conflicrIndicator.rule")}
                      variant="outlined"
                      disabled={true}
                      onChange={handleChange}
                      error={error}
                      helperText={error ? "This field is required." : ""}
                      sx={{
                        width: "100%", // Custom styling
                        "& .MuiOutlinedInput-root": {
                          height: "40px", // Set height of the input
                          borderRadius: "10px",
                          fontSize: "14px",

                          boxShadow:
                            "2px 0px 4px 0px rgba(236, 235, 235, 0.50), -2px 0px 4px 0px rgba(236, 235, 235, 0.50), 0px 2px 4px 0px rgba(236, 235, 235, 0.50)",
                          "& fieldset": {
                            borderColor: error ? "red" : "#ffffff",
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ffffff", // Change border color on hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff", // Change border color when focused

                            fontStyle: "italic",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          lineHeight: "20px", // Align the label vertically
                          transform: "translate(10px, 10px) scale(1)", // Adjust label position
                          fontStyle: "italic",
                          color: "#A7A9B0",
                          fontSize: "14px",
                          fontWeight: "normal500",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          transform: "translate(14px, -6px) scale(0.75)", // Adjust label position when focused
                        },
                      }}
                    />{" "}
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  padding: "20px 30px",
                  borderBottom: "solid 1px  rgba(14, 43, 99, 0.2)",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      placeholder={t("conflicrIndicator.functionality1")}
                      variant="outlined"
                      value={func1.name}
                      onChange={handleChange}
                      error={error}
                      helperText={error ? "This field is required." : ""}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      sx={{
                        width: "100%", // Custom styling
                        "& .MuiOutlinedInput-root": {
                          height: "40px", // Set height of the input
                          borderRadius: "10px",
                          fontSize: "14px",
                          fontStyle:"italic",

                          boxShadow:
                            "2px 0px 4px 0px rgba(236, 235, 235, 0.50), -2px 0px 4px 0px rgba(236, 235, 235, 0.50), 0px 2px 4px 0px rgba(236, 235, 235, 0.50)",
                          "& fieldset": {
                            borderColor: error ? "red" : "#ffffff",
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ffffff", // Change border color on hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff", // Change border color when focused

                            fontStyle: "italic",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          lineHeight: "20px", // Align the label vertically
                          transform: "translate(10px, 10px) scale(1)", // Adjust label position
                          fontStyle: "italic",
                          color: "#A7A9B0",
                          fontSize: "14px",
                          fontWeight: "normal500",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          transform: "translate(14px, -6px) scale(0.75)", // Adjust label position when focused
                        },
                      }}
                    />{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      placeholder={t("conflicrIndicator.functionality2")}
                      variant="outlined"
                      value={func2.name}
                      onChange={handleChange}
                      error={error}
                      helperText={error ? "This field is required." : ""}
                      onDrop={handleDrop2}
                      onDragOver={handleDragOver2}
                      sx={{
                        width: "100%", // Custom styling
                        "& .MuiOutlinedInput-root": {
                          height: "40px", // Set height of the input
                          borderRadius: "10px",
                          fontSize: "14px",
                          fontStyle:"italic",
                          boxShadow:
                            "2px 0px 4px 0px rgba(236, 235, 235, 0.50), -2px 0px 4px 0px rgba(236, 235, 235, 0.50), 0px 2px 4px 0px rgba(236, 235, 235, 0.50)",
                          "& fieldset": {
                            borderColor: error ? "red" : "#ffffff",
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ffffff", // Change border color on hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff", // Change border color when focused

                            fontStyle: "italic",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          lineHeight: "20px", // Align the label vertically
                          transform: "translate(10px, 10px) scale(1)", // Adjust label position
                          fontStyle: "italic",
                          color: "#A7A9B0",
                          fontSize: "14px",
                          fontWeight: "normal500",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          transform: "translate(14px, -6px) scale(0.75)", // Adjust label position when focused
                        },
                      }}
                    />{" "}
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ padding: "20px 30px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      value={searchQuery}
                      onChange={handleSearch}
                      placeholder={t("search")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        width: "100%", // Custom styling
                        "& .MuiOutlinedInput-root": {
                          height: "40px", // Set height of the input
                          borderRadius: "10px",
                          fontSize: "14px",
                          fontStyle:"italic",
                          boxShadow:
                            "2px 0px 4px 0px rgba(236, 235, 235, 0.50), -2px 0px 4px 0px rgba(236, 235, 235, 0.50), 0px 2px 4px 0px rgba(236, 235, 235, 0.50)",
                          "& fieldset": {
                            borderColor: error ? "red" : "#ffffff",
                            borderWidth: "1px",
                          },
                          "&:hover fieldset": {
                            borderColor: "#ffffff", // Change border color on hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ffffff", // Change border color when focused

                            fontStyle: "italic",
                          },
                        },
                        "& .MuiInputLabel-root": {
                          lineHeight: "20px", // Align the label vertically
                          transform: "translate(10px, 10px) scale(1)", // Adjust label position
                          fontStyle: "italic",
                          color: "#A7A9B0",
                          fontSize: "14px",
                          fontWeight: "normal500",
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                          transform: "translate(14px, -6px) scale(0.75)", // Adjust label position when focused
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    {filteredResults.length > 0 ? (filteredResults.map((item, index) => (
                      <Accordion
                        key={index}
                        expanded={expanded === `panel${index}`}
                        onChange={handleChanges(`panel${index}`)}
                        sx={{
                          backgroundColor: "transparent",
                          borderTop: "1px solid rgba(14, 43, 99, 0.2)",
                          boxShadow: "none",
                          "&:before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${index}-content`}
                          id={`panel${index}-header`}
                          sx={{
                            fontSize: "14px",
                            fontWeight: "700",
                            color: "#191E31",
                            textTransform: "uppercase",
                            "& .MuiAccordionSummary-content": {
                              margin: 0,
                            },
                          }}
                        >
                          <Typography sx={{  fontWeight: "700"}}>{item.headingName}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            fontSize: "14px",
                            color: "#191E31",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: "20px",
                              flexWrap: "wrap",
                            }}
                          >
                            
                      
                            
                            {item?.mergedSubHeadings?.map((subHeading) => (
                              <>

<Box  sx={{
  fontSize: "14px",
  width:"100%",
  fontWeight: "700",
  color: "#191E31",
  textTransform: "uppercase",

}}>

<Typography sx={{  fontWeight: "600", fontSize:"14px"}}>{subHeading.subHeadingName}</Typography>
  </Box>
  {subHeading?.headingData?.map((data) => (
                              <Box key={data.functionality_id}>
                                <Typography
                                  draggable
                                  onDragStart={(event) =>
                                    handleDragStart(event, data)
                                  }
                                  sx={{
                                    borderRadius: "16px",
                                    background: "#ffffff",
                                    boxShadow:
                                      "0px 2px 4px 0px rgba(0, 0, 0, 0.16)",
                                    display: "inline-flex",
                                    gap: "15px",
                                    alignItems: "start",
                                    padding: "12px 20px",
                                    maxWidth: "361px",
                                  }}
                                >
                                  {" "}
                                  <img
                                    src={drag} // Replace with your image URL
                                    alt="icon"
                                    style={{
                                      width: "15px", // Set custom width
                                      height: "15px",
                                      marginTop: "4px",
                                    }}
                                  />{" "}
                                  {data.functionality_name}
                                </Typography>
                              </Box>
  ))}
                              </>
                            ))}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    ))):null}
                  </Grid>
                </Grid>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTop: "solid 1px  rgba(14, 43, 99, 0.2)",
                padding: "30px 30px",
                gap: "20px",
              }}
            >
              <Button
                // variant="outlined"
                onClick={() => navigate("/conflictIndicator")}
                sx={{
                    pt: '8px',
                    pr: '20px',
                    pb: '8px',
                    pl: '20px',
                    background: '#737d86',
                    boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                    fontWeight: 500,
                    borderRadius: "6px",
                    border: '0.739px solid #FFF',
                    color: '#ffffff',
                    fontSize: '14px',
                    fontFamily: 'Montserrat',
                    textTransform: 'uppercase',
                    fontWeight: '500',
                    '&:hover': {
                        background: '#737d86', // Hover background color
                        color: '#ffffff',      // Hover text color
                        opacity: 1,            // Ensure opacity is 1 on hover
                      }
                }}
              >
               {t("back")}
              </Button>
              <Button
                // variant="outlined"
                onClick={createRule}
                disabled={!(func1.name !=="" && func2.name !== "")}
                sx={{
                    pt: '8px',
                    pr: '20px',
                    pb: '8px',
                    pl: '20px',
                    background: '#ef7d00',
                    boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                    fontWeight: 500,
                    borderRadius: "6px",
                    border: '0.739px solid #FFF',
                    color: '#ffffff',
                    fontSize: '14px',
                    fontFamily: 'Montserrat',
                    textTransform: 'uppercase',
                    fontWeight: '500',
                    opacity: 1, // Set initial opacity
                    '&:hover': {
                      background: '#ef7d00', // Hover background color
                      color: '#ffffff',      // Hover text color
                      opacity: 1,            // Ensure opacity is 1 on hover
                    }
                  }}
              >
                {t("submit")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default CreateNewRule;
